<template>
  <transition name="fade-layout">
      <div class="public-layout">
          <transition name="fade" mode="out-in">
              <div v-if="data.ready" class="content-wrapper" >
                  <div :class="{'disabled': data.loading}">

                    <div class="content">
                        <!-- Content -->
                        <slot />
                        <div v-if="currentAcceptedPrivacyPolicy && isRegisterPage()" class="botman-ico"><img src="../../../images/botman-icon.png" @click="openBotman()" /></div>
                    </div>

                    <div class="footer-logos">
                      <img src="../../../images/home/ue-logo.png" alt="Financiado por la Unión Europea NextGenerationEU" />
                      <img class="borde" src="../../../images/home/gobierno-espana-logo.png" alt="Gobierno de España" />
                      <img class="borde" src="../../../images/home/plan-recuperacion-logo.png" alt="Plan de Recuperación, Transformación y Resiliencia" />
                      <img src="../../../images/home/gradiant-logo.png" alt="Gradiant" />
                      <img src="../../../images/home/coop-armadores-logo.png" alt="Cooperativa de Armadores del Puerto de Vigo" />
                      <img src="../../../images/home/nextempleamar-logo-2.png" alt="NextempleaMar" />
                      <div class="financiacion-text">Este proyecto está financiado por el Plan de Recuperación, Transformación y Resiliencia y los Fondos Europeos Next Generation EU, en el marco del Real Decreto 685/2021, del 3 de agosto</div>
                    </div>
                  </div>
              </div>
          </transition>
          <flash-message :flash="$attrs.flash" />
      </div>
  </transition>
</template>

<script>
import { Inertia } from '@inertiajs/inertia';
import { ref, onMounted, watch } from "vue";
import FlashMessage from "../FlashMessage";
import { useCookies } from "vue3-cookies";

export default
{
    name: "PublicLayout",
    components: {
        FlashMessage,
    },
    props: {
      acceptedPrivacyPolicy: Boolean
    },

    setup(props){
      const { cookies } = useCookies();

      const currentAcceptedPrivacyPolicy = ref(props.acceptedPrivacyPolicy);
      const botmanWidgetRoot = ref(null);
      const closedMessageAvatars = ref([]);
      const currentUrl = window.location.href;

      const data = ref({
            ready: false,
            loading: true,
            transition: false,
            success: [],
            error: []
      });

      const isRegisterPage = () => {
        const regex = /\/login\b|^\/$|\/$/;
        return regex.test(currentUrl);
      };

      console.log(isRegisterPage());

      const openBotman = (event) => {
        botmanChatWidget.toggle();
        if (botmanChatWidget.widget.state.isChatOpen) {
          botmanWidgetRoot.value.style.display = 'block';
        }
        else {
          botmanWidgetRoot.value.style.display = 'none';
        }
      }

      const loadExternalScript = () => {
          const script = document.createElement('script');
          script.src = 'https://cdn.jsdelivr.net/npm/botman-web-widget@0/build/js/widget.js';
          script.async = true;
          document.head.appendChild(script);
      }

      onMounted( () => {

        data.value.ready = true;
        data.value.loading = false;

        loadExternalScript();

        currentAcceptedPrivacyPolicy.value = false;
        if (cookies.isKey("acceptedPrivacyPolicy")) {
          currentAcceptedPrivacyPolicy.value = true;
        }
        else if (props.acceptedPrivacyPolicy) {
          currentAcceptedPrivacyPolicy.value = true;
          cookies.set("acceptedPrivacyPolicy", "true", -1);

        }

        Inertia.on( 'start', ( event ) =>
        {
            if ( !event.detail.visit.preserveState )
            {
                data.value.ready = false;
            }
        } ),
        Inertia.on( 'finish', ( event ) =>
        {
            data.value.ready = true;
            data.value.loading = false;
        });

        const observer = new MutationObserver((mutationsList) => {
          for (const mutation of mutationsList) {
            // Verificar si se ha agregado un elemento con id "botmanWidgetRoot"
            if (mutation.type === 'childList' && mutation.addedNodes) {
              for (const node of mutation.addedNodes) {
                if (node.id === 'botmanWidgetRoot') {
                  // Asignar el elemento a la referencia
                  botmanWidgetRoot.value = node;

                  // Realizar acciones en el elemento, por ejemplo, cambiar el estilo
                  if (botmanWidgetRoot.value) {
                    botmanWidgetRoot.value.style.display = 'none'; // Ocultar el elemento
                  }

                  // Dejar de observar cambios una vez que se ha encontrado el elemento
                  //observer.disconnect();
                }

                if (mutation.type === 'childList' || mutation.type === 'attributes') {
                  const avatars = Array.from(
                    document.querySelectorAll('[class$="-closed-message-avatar"]')
                  );
                  closedMessageAvatars.value = avatars;

                  // Realizar acciones en los elementos encontrados
                  avatars.forEach((avatar) => {
                    avatar.style.display = 'none'; // Ocultar el elemento
                  });
                }
              }
            }
          }
        });

        // Comenzar a observar cambios en el DOM
        observer.observe(document.body, { childList: true, subtree: true, attributes: true });
        
      });

      watch(
        () => props.acceptedPrivacyPolicy,
        (newVal) => {
          if (!cookies.isKey("acceptedPrivacyPolicy")) {
            cookies.set("acceptedPrivacyPolicy", "true", -1);
          }
          currentAcceptedPrivacyPolicy.value = newVal;
        }
      );

      return {
          data,
          cookies,
          currentAcceptedPrivacyPolicy,
          openBotman,
          botmanWidgetRoot,
          closedMessageAvatars,
          isRegisterPage
      }
    },
}
</script>

<style lang="scss">
@import "../../../sass/variables"; // Variables
#app{
  overflow-x: hidden;
}

.public-layout{
  background-image: url("../../../images/home/home-bg@2x.jpg");
  background-position: center center;
  @media (min-width: 1200px) {
    background-position: right top;
  }
  background-size: cover;
  display:flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 30px;
  .content-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;

    .content {
      padding: 50px 30px 85px 30px;
      @media (min-width: 1200px) {
        padding: 65px;
      }
      background: rgba(255,255,255,0.6);
      box-shadow: 0px 8px 6px #00000029;
      border-radius: 20px;
      max-width: 550px;
      margin: 0 auto;
      position: relative;
      .logo-login {
        img {
          max-width: 100%;
        }
      }
      .txt-intro {
        color: white;
        font-weight: bold;
        font-size: 16px;
        text-align: center;
        margin: 0 auto;
      }
      .botman-ico {
        background: $color-brand-1;
        padding: 20px;
        border-radius: 50%;
        width: 55px;
        height: 55px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        position: absolute;
        right: 20px;
        bottom: 20px;
      }
      .card-body {
        padding: 1.25rem 0;
        @media (min-width: 768px) {
          padding: 1.25rem;
        }
      }
      form {
        .bmd-form-group {
          background: white;
        }
        .btn.btn-primary, .btn-primary.custom-file-control::before, .btn.btn-raised.btn-primary {
          background-color: $color-brand-1;
        }
      }
      a.form-link {
        color: $color-brand-1;
        &:hover {
          text-decoration: underline;
          color: $color-brand-1
        }
      }
      .cookie-consent {
        border-top: 1px solid white;
        margin-top:40px;
        color: $color-brand-1;
        .tit {
          text-transform: uppercase;
          font-weight: bold;
          font-size: 24px;
          color: $color-brand-1;
        }
        .btn.btn-raised.btn-primary {
          background-color: $color-brand-2;
        }
        a {
          color: $color-brand-1;
          text-decoration: underline;
        }
      }
    }
    .footer-logos {
      margin-top: 50px;
      background: white;
      padding: 5px 30px;
      border-radius: 30px;
      text-align: center;
      div.financiacion-text {
        font-size: 0.6rem;
        line-height: 12px;
      }
      img:not(:last-child){
        margin-right:10px;
        &.borde {
          @media (min-width: 768px) {
            border-right: 1px solid #ccc;
            padding-right:10px;
          }
        }
      }
    }
  }
}

.public-layout {
  #botmanWidgetRoot {
    #chatBotManFrame {
      display: none !important; //Ocultar btn nativo de botman
    }
    .desktop-closed-message-avatar {
      display: none !important; //Ocultar btn nativo de botman
    }
  }
}
</style>
